/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'signout': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M20.8 7.5l-1.5 1.4 6.1 6.1H7v2h18.4l-6.1 6.1 1.5 1.4 8.5-8.5z"/><path pid="1" d="M4 5h4V3H2v26h6v-2H4z"/>'
  }
})
